const ZENDESK_BASE_URL = 'https://static.zdassets.com/ekr/snippet.js';

const ZENDESK_KEY = 'c1615337-97cc-41d3-8ccc-e7114032f86a';

const startZendeskApp = () => {
  const script = document.createElement('script');
  script.src = `${ZENDESK_BASE_URL}?key=${ZENDESK_KEY}`;
  script.id = 'ze-snippet';

  document.getElementsByTagName('head')[0].appendChild(script);

  return true;
};

export default startZendeskApp;
